import { Download, Visibility } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { toast } from "react-toastify";

import { GetBinary } from "@/services/fhir/patientsummary/Binary/GetBinary";
import { downloadFile } from "@/utils/fileDownloadHelper";

interface PatientPrescriptionCardActionsProps {
  row: { binaryUrl?: string; description?: string };
  handleOpen?: () => void;
  setBinaryUrl?: (url: string) => void;
  compact?: boolean;
}

export function PatientPrescriptionCardActions({
  row,
  handleOpen,
  setBinaryUrl,
  compact = false,
}: PatientPrescriptionCardActionsProps) {
  async function handleDownload() {
    if (!row?.binaryUrl) {
      toast.warn("Documento ainda não disponível.");
      return;
    }
    try {
      const response = await GetBinary({ urlBinary: row.binaryUrl });
      downloadFile(response?.data, "Receita.pdf", response?.contentType);
    } catch {
      toast.error("Erro ao baixar documento.");
    }
  }

  function handleView() {
    if (!row?.binaryUrl) {
      toast.warn("Documento ainda não disponível.");
      return;
    }
    setBinaryUrl?.(row.binaryUrl);
    handleOpen?.();
  }

  return (
    <Stack direction="row" spacing={compact ? 0.75 : 1} width="100%">
      <Button
        variant="outlined"
        color="primary"
        size="small"
        fullWidth
        startIcon={<Visibility sx={{ fontSize: compact ? 16 : 18 }} />}
        onClick={handleView}
        disabled={!row?.binaryUrl}
        sx={{
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          fontSize: compact ? "0.75rem" : "0.8125rem",
          py: compact ? 0.45 : 0.75,
          minHeight: compact ? 32 : undefined,
        }}
      >
        Visualizar
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="small"
        fullWidth
        startIcon={<Download sx={{ fontSize: compact ? 16 : 18 }} />}
        onClick={handleDownload}
        disabled={!row?.binaryUrl}
        sx={{
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          fontSize: compact ? "0.75rem" : "0.8125rem",
          py: compact ? 0.45 : 0.75,
          minHeight: compact ? 32 : undefined,
        }}
      >
        Baixar
      </Button>
    </Stack>
  );
}
